// =============================================================================
// FILE:
// frontend/src/pms/task_execution/tabs/OverviewTab.js
// =============================================================================

import React from "react";


// =============================================================================
// COMPONENT
// =============================================================================

export default function OverviewTab({

  task

}) {


  return (

    <div style={styles.container}>


      {/* ================================================================ */}
      {/* TOP SUMMARY */}
      {/* ================================================================ */}
      <div style={styles.topGrid}>


        {/* ============================================================ */}
        {/* TASK INFO */}
        {/* ============================================================ */}
        <div style={styles.card}>


          <div style={styles.cardTitle}>

            Task Information

          </div>


          <div style={styles.infoGrid}>


            <InfoItem
              label="Task"
              value={task.task_name}
            />


            <InfoItem
              label="Phase"
              value={task.phase_name}
            />


            <InfoItem
              label="Project"
              value={
                task.project_name ||
                "Receiver Vessel Project"
              }
            />


            <InfoItem
              label="Priority"
              value={
                task.priority ||
                "NORMAL"
              }
            />


            <InfoItem
              label="Execution Status"
              value={
                task.execution_status ||
                "NOT_STARTED"
              }
            />


            <InfoItem
              label="Readiness"
              value={
                `${task.readiness_percent || 0}%`
              }
            />

          </div>

        </div>


        {/* ============================================================ */}
        {/* READINESS */}
        {/* ============================================================ */}
        <div style={styles.card}>


          <div style={styles.cardTitle}>

            Execution Readiness

          </div>


          <div style={styles.readinessWrap}>


            <div style={styles.readinessCircle}>


              <div style={styles.readinessValue}>


                {

                  task.readiness_percent || 0

                }%

              </div>


              <div style={styles.readinessLabel}>

                READY

              </div>

            </div>


            <div style={styles.readinessLegend}>


              <LegendItem
                color="#16a34a"
                label="Ready"
              />


              <LegendItem
                color="#ea580c"
                label="Waiting"
              />


              <LegendItem
                color="#dc2626"
                label="Blocked"
              />

            </div>

          </div>

        </div>

      </div>


      {/* ================================================================ */}
      {/* EXECUTION METRICS */}
      {/* ================================================================ */}
      <div style={styles.metricsGrid}>


        <MetricCard
          title="Planned Materials"
          value={
            task.total_materials || 0
          }
          color="#2563eb"
        />


        <MetricCard
          title="Pending Requests"
          value={
            task.pending_requests || 0
          }
          color="#ea580c"
        />


        <MetricCard
          title="Approved Requests"
          value={
            task.approved_requests || 0
          }
          color="#16a34a"
        />


        <MetricCard
          title="Issues Completed"
          value={
            task.total_issues || 0
          }
          color="#7c3aed"
        />

      </div>


      {/* ================================================================ */}
      {/* EXECUTION SUMMARY */}
      {/* ================================================================ */}
      <div style={styles.card}>


        <div style={styles.cardTitle}>

          Execution Summary

        </div>


        <div style={styles.summaryText}>


          This task is currently in

          {" "}

          <strong>

            {
              task.execution_status ||

              "NOT_STARTED"
            }

          </strong>

          {" "}

          status with

          {" "}

          <strong>

            {
              task.readiness_percent || 0
            }%

          </strong>

          {" "}

          execution readiness.

          Pending material requests,
          warehouse issues,
          reconciliation status,
          and inventory availability
          directly affect execution readiness.

        </div>

      </div>

    </div>
  );
}


// =============================================================================
// INFO ITEM
// =============================================================================

function InfoItem({

  label,

  value

}) {

  return (

    <div style={styles.infoItem}>


      <div style={styles.infoLabel}>

        {label}

      </div>


      <div style={styles.infoValue}>

        {value || "-"}

      </div>

    </div>
  );
}


// =============================================================================
// METRIC CARD
// =============================================================================

function MetricCard({

  title,

  value,

  color

}) {

  return (

    <div
      style={{
        ...styles.metricCard,

        borderTop:
          `4px solid ${color}`
      }}
    >

      <div style={styles.metricTitle}>

        {title}

      </div>


      <div style={styles.metricValue}>

        {value}

      </div>

    </div>
  );
}


// =============================================================================
// LEGEND ITEM
// =============================================================================

function LegendItem({

  color,

  label

}) {

  return (

    <div style={styles.legendItem}>


      <div
        style={{
          ...styles.legendDot,
          background: color
        }}
      />


      <span>

        {label}

      </span>

    </div>
  );
}


// =============================================================================
// STYLES
// =============================================================================

const styles = {

  container: {

    display: "flex",

    flexDirection: "column",

    gap: 20
  },

  topGrid: {

    display: "grid",

    gridTemplateColumns:
      "2fr 1fr",

    gap: 20
  },

  card: {

    background: "#ffffff",

    borderRadius: 14,

    padding: 20,

    boxShadow:
      "0 1px 4px rgba(0,0,0,0.08)"
  },

  cardTitle: {

    fontSize: 16,

    fontWeight: 700,

    marginBottom: 18,

    color: "#111827"
  },

  infoGrid: {

    display: "grid",

    gridTemplateColumns:
      "repeat(2, 1fr)",

    gap: 18
  },

  infoItem: {

    display: "flex",

    flexDirection: "column"
  },

  infoLabel: {

    fontSize: 12,

    color: "#6b7280",

    marginBottom: 6
  },

  infoValue: {

    fontSize: 14,

    fontWeight: 600,

    color: "#111827"
  },

  readinessWrap: {

    display: "flex",

    flexDirection: "column",

    alignItems: "center",

    justifyContent: "center",

    height: "100%"
  },

  readinessCircle: {

    width: 140,

    height: 140,

    borderRadius: "50%",

    border: "10px solid #16a34a",

    display: "flex",

    flexDirection: "column",

    alignItems: "center",

    justifyContent: "center"
  },

  readinessValue: {

    fontSize: 34,

    fontWeight: 700,

    color: "#111827"
  },

  readinessLabel: {

    fontSize: 12,

    color: "#6b7280",

    marginTop: 4
  },

  readinessLegend: {

    marginTop: 18,

    display: "flex",

    gap: 16
  },

  legendItem: {

    display: "flex",

    alignItems: "center",

    gap: 8,

    fontSize: 12
  },

  legendDot: {

    width: 10,

    height: 10,

    borderRadius: "50%"
  },

  metricsGrid: {

    display: "grid",

    gridTemplateColumns:
      "repeat(4, 1fr)",

    gap: 16
  },

  metricCard: {

    background: "#ffffff",

    borderRadius: 14,

    padding: 18,

    boxShadow:
      "0 1px 4px rgba(0,0,0,0.08)"
  },

  metricTitle: {

    fontSize: 13,

    color: "#6b7280",

    marginBottom: 10
  },

  metricValue: {

    fontSize: 28,

    fontWeight: 700,

    color: "#111827"
  },

  summaryText: {

    fontSize: 14,

    lineHeight: "24px",

    color: "#374151"
  }
};